import request from '@/utils/request'

// ========== 导航栏管理 ==========
export function getNavbarList(params) {
  return request({
    url: '/api/admin/navbar',
    method: 'get',
    params
  })
}

export function getNavbarById(id) {
  return request({
    url: `/api/admin/navbar/${id}`,
    method: 'get'
  })
}

export function addNavbar(data) {
  return request({
    url: '/api/admin/navbar',
    method: 'post',
    data
  })
}

export function updateNavbar(id, data) {
  return request({
    url: `/api/admin/navbar/${id}`,
    method: 'put',
    data
  })
}

export function deleteNavbar(id) {
  return request({
    url: `/api/admin/navbar/${id}`,
    method: 'delete'
  })
}

export function updateNavbarStatus(id, status) {
  return request({
    url: `/api/admin/navbar/${id}/status`,
    method: 'post',
    params: { status }
  })
}

// 前台获取启用的导航栏
export function getActiveNavbar() {
  return request({
    url: '/api/navbar',
    method: 'get'
  })
}
